export enum EventType {
    Ready = "device:ready",
    ReadyAck = "device:ready:ack",
    DeviceConnected = "device:connected",
    DeviceDisconnected = "device:disconnected",
    RequestStatus = "device:status:request",
    StatusResponse = "device:status:response",
    RebootRequest = "device:reboot:request",
    RebootResponse = "device:reboot:response",
    MonitorRequest = "device:monitor:request",
    MonitorResponse = "device:monitor:response",
    MonitorStatus = "device:monitor:status",
    ScreenshotRequest = "device:screenshot:request",
    ScreenshotResponse = "device:screenshot:response",
    ScreenshotPolicy = "device:screenshot:policy",
    AuditSend = "device:audit:send",
    AuditResponse = "device:audit:response",
    Error = "device:error",
    UpdaterManifestUrlRequest = "updater:manifest-url:request",
    UpdaterManifestUrlResponse = "updater:manifest-url:response",
}

export type DeviceStatus = "online" | "offline";

export type EventPayloads = {
    [EventType.Ready]: {
        version?: string;
    };
    [EventType.ReadyAck]: {
        frontendVersion?: string;
        backendVersion?: string;
    };
    [EventType.DeviceConnected]: {
        deviceId: string;
    };
    [EventType.DeviceDisconnected]: {
        deviceId: string;
    };
    [EventType.RequestStatus]: {
        requestId: string;
        deviceId: string;
    };
    [EventType.StatusResponse]: {
        requestId: string;
        deviceId: string;
        status: DeviceStatus;
    };
    [EventType.RebootRequest]: {
        requestId: string;
        deviceId: string;
    };
    [EventType.RebootResponse]: {
        requestId: string;
        deviceId: string;
        success: boolean;
    };
    [EventType.ScreenshotRequest]: {
        requestId: string;
        deviceId: string;
    };
    [EventType.ScreenshotResponse]: {
        requestId: string;
        deviceId: string;
        imageBase64: Uint8Array<ArrayBuffer>;
    };
    /* see docs/EXTRACTED_COMMENTS.md#c763 */
    [EventType.ScreenshotPolicy]: {
        interval: number;
        retention: number;
        offloadTimestamp: {
            hour: number;
            minute: number;
            second: number;
        };
        deviceId?: string;
    };
    /* DCS `device_action.request_audit_upload`: hand the stored captures over
       now instead of waiting for the policy's daily offload window. */
    [EventType.AuditSend]: {
        requestId: string;
        deviceId: string;
    };
    [EventType.AuditResponse]: {
        requestId: string;
        deviceId: string;
        success: boolean;
        uploaded: number;
        error?: string;
    };
    [EventType.MonitorRequest]: {
        requestId: string;
        deviceId: string;
        cmd: string;
        data: string;
    };
    [EventType.MonitorResponse]: {
        requestId: string;
        deviceId: string;
        data?: string;
    };
    [EventType.MonitorStatus]: {
        manufacturer: string;
        productCode: number;
        profile: string;
        power?: string;
        backlight?: number;
        source?: string;
        error?: string;
    };
    [EventType.Error]: {
        requestId?: string;
        code: string;
        message: string;
        details?: unknown;
    };
    [EventType.UpdaterManifestUrlRequest]: {
        requestId: string;
    };
    [EventType.UpdaterManifestUrlResponse]: {
        requestId?: string;
        manifestUrl: string | null;
    };
};

export type EventMessage<T extends EventType> = {
    type: T;
    payload: EventPayloads[T];
};
